import { render } from "./BoxView.vue?vue&type=template&id=c973ba2a&scoped=true"
import script from "./BoxView.vue?vue&type=script&lang=js"
export * from "./BoxView.vue?vue&type=script&lang=js"

import "./BoxView.vue?vue&type=style&index=0&id=c973ba2a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c973ba2a"]])

export default __exports__